// @flow
import * as React from 'react'
import ContentWidthConstraint from 'ui/ContentWidthConstraint'

import './PageContent.scss'

type Props = {
  children: React.Node,
}

export default class PageContent extends React.Component<Props> {
  render = () => {
    return (
      <div className="PageContent">
        <ContentWidthConstraint>{this.props.children}</ContentWidthConstraint>
      </div>
    )
  }
}
